import { useEffect, useState } from "react";
import { Text, Title } from "@vkontakte/vkui";

type PartnerMediaProps = {
  title: string;
  category?: string;
  logoUrl?: string | null;
  coverUrl?: string | null;
  variant?: "compact" | "detail";
};

function initials(title: string) {
  return title
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

export function PartnerMedia({ title, category, logoUrl, coverUrl, variant = "compact" }: PartnerMediaProps) {
  const [coverFailed, setCoverFailed] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);
  const hasCover = Boolean(coverUrl) && !coverFailed;
  const hasLogo = Boolean(logoUrl) && !logoFailed;

  useEffect(() => {
    setCoverFailed(false);
  }, [coverUrl]);

  useEffect(() => {
    setLogoFailed(false);
  }, [logoUrl]);

  return (
    <div className={`partner-media partner-media--${variant} ${hasCover ? "partner-media--image" : ""}`}>
      {hasCover ? (
        <img className="partner-media__cover" src={coverUrl || ""} alt="" loading="lazy" onError={() => setCoverFailed(true)} />
      ) : null}
      <div className="partner-media__shade" />
      <div className="partner-media__content">
        <div className="partner-media__logo" aria-hidden={!hasLogo}>
          {hasLogo ? (
            <img src={logoUrl || ""} alt={`Логотип ${title}`} loading="lazy" onError={() => setLogoFailed(true)} />
          ) : (
            <span>{initials(title) || "К"}</span>
          )}
        </div>
        <div className="partner-media__text">
          {variant === "detail" ? <Title level="2">{title}</Title> : <Title level="3">{title}</Title>}
          {category ? <Text className="partner-media__category">{category}</Text> : null}
        </div>
      </div>
    </div>
  );
}
